import { render } from "./Bold.vue?vue&type=template&id=3d1f0d8e"
import script from "./Bold.vue?vue&type=script&lang=js"
export * from "./Bold.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SanttuLehtinen\\Projektit\\vetera\\vetera-management\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__